<template>
    <v-dialog
      v-model="openDeleteDirectChatDialog"
      persistent
      max-width="290"
      class="close-direct-message-dialog"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{$t('chat.closeDm.title')}}
        </v-card-title>
        <v-card-text>{{$t('chat.closeDm.message')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            {{$t('chat.closeDm.btn.cancel')}}
          </v-btn>
          <v-btn
            color="red"
            text
            @click="deleteDirectChat()"
          >
            {{$t('chat.closeDm.btn.submit')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-deleteDirectChatDialog',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      openDeleteDirectChatDialog: 'chat/openDeleteDirectChatDialog'
    })
  },
  methods: {
    ...mapActions({
      closeDialog: 'chat/openDeleteDirectChatDialog',
      deleteDirectChat: 'chat/deleteDirectChat'
    })

  }
}
</script>

<style scoped>
</style>
